// extracted by mini-css-extract-plugin
module.exports = {"list":"ListComponentHighlight_list__JMaTU"};